<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span class="main-r_top_nav active">{{$t('apiDoc.在线文档')}}</span>
      <!-- 测试工具已屏蔽
      <span class="main-r_top_nav" :class="mainStatus === 'apiTest' && 'active'" @click.stop="handleClick('apiTest')">{{$t('apiDoc.测试工具')}}</span>
      -->
    </div>
    <div class="main-r-bottom">
      <online-doc :onlineData="onlineData"></online-doc>
    </div>
    <!-- 测试工具已屏蔽
    <div class="main-r-bottom" v-show="mainStatus === 'apiTest'">
      <api-test-doc :apiTestData="apiTestData"></api-test-doc>
    </div>
    -->
  </div>
</template>
<script>
import onlineDoc from "../components/onlineDoc";
// import apiTestDoc from "../components/apiTestDoc";
import {OPEN_API_TEST,OPEN_API_PRO} from '@/constants/index'
const apiUrlTest = 'order/updateDir';
export default {
  components: { onlineDoc },
  data() {
    return {
      apiBaseUrl: process.env.VUE_APP_API_URL + `/${apiUrlTest}`,
      onlineData: {
        apiDesc: `${this.$t('customsDoc.updateDirDesc')}`,
        testApi: `${OPEN_API_TEST}/${apiUrlTest}`,
        proApi: `${OPEN_API_PRO}/${apiUrlTest}`,
        postDataList: [
          { title: `${this.$t('onlineDoc.Headers')}`, value: [
              {name: "apiAccount", type: "Number", require: "Y", normal: "", describe: `${this.$t('onlineDoc.接入方在平台的api账户标识')}`},
              {name: "digest", type: "String", require: "Y", normal: "", describe: `${this.$t('onlineDoc.签名字符串')}`},
              {name: "timestamp", type: "Number", require: "Y", normal: "", describe: `${this.$t('onlineDoc.时间戳，毫秒')}`},
          ]},
          { title: `${this.$t('onlineDoc.请求参数')}`, value: [
              {name: "bizContent", type: "String", require: "Y", normal: `${this.$t('onlineDoc.业务参数')}`, describe: `${this.$t('onlineDoc.业务参数模块内json格式的string类型')}`},
          ]},
          { title: `${this.$t('onlineDoc.业务参数')}`, value: [
              {name: "customerCode", type: "String", require: "Y", normal: "J0086474299", describe: `${this.$t('onlineDoc.客户编码（联系出货网点提供）')}`},
              {name: "digest", type: "String", require: "Y", normal: `${this.$t('onlineDoc.明文密码:H5CD3zE6')}`, describe: `${this.$t('customsDoc.digestDesc')}`},
              {name: "billCode", type: "String(50)", require: "Y", normal: "", describe: `${this.$t('customsDoc.billCodeTxlogisticId')}`},
              {name: "txlogisticId", type: "String", require: "Y", normal: "", describe: `${this.$t('customsDoc.billCodeTxlogisticId')}`},
              {name: "invoiceMoney", type: "Number", require: "Y", normal: "123.45", describe: `${this.$t('customsDoc.dirAmount')}`},
              {name: "invoiceNumber", type: "String", require: "Y", normal: "", describe: `${this.$t('customsDoc.dirNumber')}`},
              {name: "invoiceIssueDate", type: "String", require: "Y", normal: "", describe: `${this.$t('customsDoc.dirRegDate')}`},
          ]}
        ],
        responseDataList: [
          { title: `${this.$t('onlineDoc.响应参数')}`, value: [
              {name: "code", type: "String", require: "Y", normal: "", describe: `${this.$t('onlineDoc.返回码，见附录')}`},
              {name: "msg", type: "String", require: "Y", normal: "", describe: `${this.$t('onlineDoc.描述')}`},
              {name: "data", type: "Object", require: "Y", normal: "", describe: `${this.$t('onlineDoc.业务数据')}`},
          ]},
          { title: `${this.$t('onlineDoc.data类型说明')}`, value: [
              {name: "txlogisticId", type: "String", require: "Y", normal: "", describe: `${this.$t('customsDoc.customerOrderId')}`},
          ]}
        ],
        requestCode: `{
    "digest": "LwqNpN6LtWLJ+lhNCsQs/g==",
    "invoiceNumber": "260126324476",
    "invoiceMoney": "339.70",
    "customerCode": "J0086474299",
    "txlogisticId": "test12312312312",
    "invoiceIssueDate": "2026-06-27T00:45:00-03:00"
}`,
        responseCode: { "msg": "success", "code": "1", "data": [{"txlogisticId": "test12312312312"}] },
        errcodeJson: []
      },
      // apiTestData 已屏蔽
      // apiTestData: { ... }
    }
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>@import "../../css/apiTest.scss";</style>